import React from "react";
import Rules from "../../../../../config/rules";
import AbstractTextInput from "./AbstractTextInput";
import { ValidatorForm } from "react-material-ui-form-validator";
import StringHelper from "../../../../../helpers/StringHelper";

class NumSSKeyInput extends AbstractTextInput
{

    componentDidMount() {
        ValidatorForm.addValidationRule('isValidSSKey', this.isValidSSKey)
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isValidSSKey')
    }

    label = "Clé*";

    validators = !this.props.isOptional ? ['required', 'isValidSSKey'] : ['isValidSSKey'];

    errorMessages = !this.props.isOptional ? [Rules.txtRequis, Rules.txtInvalidSSKey] : [Rules.txtInvalidSSKey];

    specs = {
        style: { width: '100%' },
        helperText: "2 chiffres",
        inputProps: { maxLength: 2 }
    }

    isValidSSKey = (value) => {
        return Rules.isValidSSKey(value, StringHelper.unformatSSNum(this.props.ss))
    }

}


export default NumSSKeyInput
